module.exports = __webpack_public_path__ + "static/media/weather.d6b6e387.PNG";